export const LAYERS = {
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  dropdown: 1600,
  snackbar: 1700,
  tooltip: 1800,
  globalLoading: 1900,
} as const;
